<template>
	<label class="radio">
		<span class="h5">
			<slot></slot>
		</span>
		<input
			class="radio-button"
			type="radio"
			:name="name"
			:value="label"
			:checked="label === value"
			:disabled="disabled"
			@change="$emit('input', label)"
		/>
		<span class="checkround"></span>
	</label>
</template>

<script>
export default {
	name: 'RadioComponent',
	props: {
		name: {
			type: String,
			required: true,
		},
		label: {
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		value: null,
	},
}
</script>

<style lang="scss" scoped>
.radio {
	cursor: pointer;
	display: inline-flex;
	margin-bottom: 0;
	padding-left: 30px;
	position: relative;

	.radio-button {
		position: absolute;
		opacity: 0;
	}

	&.radio-button:checked ~ .checkround {
		background-color: #fff;
	}

	&.radio-button:checked ~ .checkround:after {
		display: block;
	}

	.checkround {
		background-color: #fff;
		border: 2px solid #d3d6d5;
		border-radius: 50%;
		position: absolute;
		top: 6px;
		left: 0;
		height: 20px;
		width: 20px;

		&:after {
			background: #01a351;
			content: '';
			display: none;
			position: absolute;
			left: 2px;
			top: 2px;
			width: 12px;
			height: 12px;
		}
	}
}
</style>
